export const FORENSIC_TAXONOMY = [
  {
    keywords: ["rg", "cnh", "identidade", "passaporte", "identificação", "cne"],
    title: "Identificação Pessoal",
    text: "Envie cópia legível (frente e verso), sem cortes ou reflexos de flash. A CNH é aceita mesmo vencida para fins de identificação."
  },
  {
    keywords: ["contrato social", "estatuto", "certidão simplificada", "cnpj", "ato constitutivo"],
    title: "Representação Empresarial",
    text: "Envie a Última Alteração do Contrato Social e a Certidão Simplificada da Junta Comercial (emitida há no máx. 30 dias). Apenas o Cartão CNPJ não é suficiente."
  },
  {
    keywords: ["residência", "endereço", "fatura", "conta de luz", "conta de água", "telefone"],
    title: "Comprovante de Endereço",
    text: "Contas de consumo (água, luz, internet) em seu nome, emitidas há no máx. 90 dias. Se estiver em nome de terceiro, anexe também uma Declaração de Residência assinada por ele."
  },
  {
    keywords: ["imposto de renda", "dirpf", "declaração de ir", "imposto"],
    title: "Imposto de Renda",
    text: "Envie a declaração completa do último exercício com todas as páginas de bens e dívidas, acompanhada do Recibo de Entrega da Receita Federal."
  },
  {
    keywords: ["holerite", "extrato", "contracheque", "comprovante de renda", "hipossuficiência"],
    title: "Prova de Renda (Justiça Gratuita)",
    text: "Envie os 3 últimos contracheques e os extratos bancários completos dos últimos 90 dias. Apenas a declaração simples de pobreza não é mais aceita pelo juiz."
  },
  {
    keywords: ["nascimento", "casamento", "óbito", "certidão civil", "averbação"],
    title: "Certidões de Registro Civil",
    text: "A certidão deve ter sido emitida pelo cartório há no máximo 90 dias para comprovar seu estado civil atualizado (averbações de divórcio, etc)."
  },
  {
    keywords: ["matrícula", "ônus reais", "imóvel", "inteiro teor"],
    title: "Matrícula de Imóvel",
    text: "A Certidão de Inteiro Teor / Ônus Reais deve ter sido expedida pelo Cartório de Registro de Imóveis há no máximo 30 dias, para evitar fraudes ou bloqueios desatualizados."
  },
  {
    keywords: ["procuração", "mandato"],
    title: "Procuração Ad Judicia",
    text: "Assine com caneta (sem rasuras e digitalize sem sombras) ou utilize Assinatura Digital com certificado ICP-Brasil/Gov.br."
  },
  {
    keywords: ["whatsapp", "telegram", "conversa", "mensagem", "rede social", "print", "áudio"],
    title: "Provas Digitais (WhatsApp/Redes)",
    text: "Prints simples de tela não têm validade. Envie o relatório de plataforma forense (ex: Verifact com código Hash) ou Ata Notarial lavrada em Cartório."
  },
  {
    keywords: ["e-mail", "email", "correio eletrônico"],
    title: "Provas de E-mail",
    text: "Salvar a tela em PDF anula a prova. Exporte e envie o arquivo original no formato .EML ou .MSG para preservar os metadados de rastreamento (IP, data, hora)."
  },
  {
    keywords: ["custas", "guia", "pagamento", "preparo", "pix", "comprovante", "pagtesouro"],
    title: "Comprovantes de Pagamento",
    text: "Agendamentos ou telas de QR Code são inválidos. Envie o Recibo Definitivo contendo o código de autenticação e a mensagem 'Pagamento realizado com sucesso'."
  }
];

export function getTooltipForSlot(slotName) {
  if (!slotName) return null;
  const nameLower = String(slotName).toLowerCase();
  return FORENSIC_TAXONOMY.find(tax => tax.keywords.some(kw => nameLower.includes(kw))) || null;
}
